/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type { FindTagsQueryResponse } from "../types/FindTags.ts"

export const findTagsQueryKey = () => [{ url: "/v1/tags" }] as const

export type FindTagsQueryKey = ReturnType<typeof findTagsQueryKey>

/**
 * @summary Find all tags
 * {@link /v1/tags}
 */
export async function findTags(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindTagsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "GET", url: `/v1/tags`, ...requestConfig })
  return res
}

export function findTagsQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findTagsQueryKey()
  return queryOptions<
    ResponseConfig<FindTagsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindTagsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findTags({ ...config, signal: config.signal ?? signal })
    },
  })
}

/**
 * @summary Find all tags
 * {@link /v1/tags}
 */
export function useFindTags<
  TData = ResponseConfig<FindTagsQueryResponse>,
  TQueryData = ResponseConfig<FindTagsQueryResponse>,
  TQueryKey extends QueryKey = FindTagsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindTagsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? findTagsQueryKey()

  const query = useQuery(
    {
      ...findTagsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
